import { render, staticRenderFns } from "./totalInfo.vue?vue&type=template&id=b847f072"
import script from "./totalInfo.vue?vue&type=script&lang=js"
export * from "./totalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports